import React, { Component } from "react"
import ReactApexChart from "react-apexcharts"

class DealPiechart extends Component {
  constructor(props) {
    super(props)
  
    this.state = {
      series: [10, 10, 10,10,10],
      options: {
        labels: ["Pre-construction", "Seller-lease", "Seller", "Buyer-Rent", "Buyer-Purchase"],
        colors:['#31356E', '#2F5F98','#2D8BBA','#41B8D5','#6CE5E8'],
        legend: {
          show: true,
          position: "bottom",
          horizontalAlign: "center",
          verticalAlign: "middle",
          floating: false,
          fontSize: "14px",
          offsetX: 0,
          offsetY: -10,
        },
        responsive: [
          {
            breakpoint: 600,
            options: {
              chart: {
                height: 240,
              },
              legend: {
                show: false,
              },
            },
          },
        ],
      },
    }
  }
  render() {
    return (
      <React.Fragment>
        <ReactApexChart
          options={this.state.options}
          series={this.state.series}
          type="pie"
          height="350"
          className="apex-charts"
        />
      </React.Fragment>
    )
  }
}

export default DealPiechart
